import styled from 'styled-components';
import { LinkButton } from '../../../../CommonComponents/Button';

export const Card = styled.div`
  border: 1px solid #e3e1e1;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 12px;
`;

export const CardHeader = styled(LinkButton)`
  height: 80px;
  border-radius: 4px;
  background: #fff;
  padding: 0 24px;
  width: 100%;
  text-align: left;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #4b4d4f;
`;

export const Content = styled.div`
  padding: 0 24px 32px;
`;

export const ShowMoreButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e3e1e1;
  background: #f6f6f6;
  margin-bottom: 12px;
  margin-top: -16px;
  height: 48px;
  color: #444;

  &&&&:hover {
    background: #f0f0f0;

    &:focus {
      background: #f0f0f0;
    }

    &:disabled {
      background: #f6f6f6;
      border: 1px solid #e3e1e1;
    }
  }

  &&&&:focus {
    background: #f6f6f6;
  }

  &&&&:disabled {
    background: #f6f6f6;
    border: 1px solid #e3e1e1;
    opacity: 1;
  }
`;
